// -------------------------------
// 件数表示ロジック
// -------------------------------
function updateVisibleSearchCount() {
  const countElement = document.querySelector('.utility-bar__centre .utility-bar__item');
  if (!countElement) return;

  const products = document.querySelectorAll('.product-block[data-product-id]');
  const visibleProductCount = products.length;

  const originalText = countElement.textContent;
  const regex = /(\d+)\s*件/;
  const match = originalText.match(regex);

  if (match && parseInt(match[1]) !== visibleProductCount) {
    countElement.textContent = originalText.replace(regex, `${visibleProductCount}件`);
  }
}

// -------------------------------
// 最低金額を¥1に強制（表示・送信値・プレースホルダー）
// -------------------------------
function updateMinPriceToOne() {
  const minPriceInput = document.querySelector('input[name="filter.v.price.gte"]');

  if (minPriceInput && (minPriceInput.value === '0' || minPriceInput.value === '' || minPriceInput.value === '¥0')) {
    minPriceInput.value = '1';
  }

  if (minPriceInput && (minPriceInput.placeholder === '0' || minPriceInput.placeholder === '¥0')) {
    minPriceInput.placeholder = '1';
  }

  const currencyInputs = document.querySelectorAll('.cc-price-range__input-container');
  currencyInputs.forEach(container => {
    const span = container.querySelector('.cc-price-range__input-currency-symbol');
    const input = container.querySelector('input');

    if (span && input && (input.placeholder === '0' || input.placeholder === '¥0')) {
      input.placeholder = '1';
    }

    if (span && span.textContent.includes('¥') && input && input.placeholder === '1' && input.value === '0') {
      input.value = '1';
    }
  });
}

// -------------------------------
// 再入荷ボタンor完売ボタンの出し分け
// -------------------------------
(function() {
  const style = document.createElement('style');
  style.textContent = `
    .btn[name="add"][disabled] {
      visibility: hidden !important;
      position: absolute !important;
      top: -9999px !important;
    }
    .show-soldout-btn .btn[name="add"][disabled] {
      visibility: visible !important;
      position: static !important;
      top: auto !important;
    }
  `;
  document.head.appendChild(style);

  function checkAndToggle() {
    const restockContainer = document.getElementById('restock-notice-btn');
    const soldOutButton = document.querySelector('.btn[name="add"][disabled]');
    const soldOutButtonContainer = soldOutButton ? soldOutButton.closest('.quantity-submit-row') : null;
    
    if (!soldOutButton || !soldOutButtonContainer) return;
    
    const hasRestockButton = restockContainer && restockContainer.children.length > 0;
    
    if (hasRestockButton) {
      // 再入荷ボタンあり：完売ボタンのコンテナ全体を非表示
      document.body.classList.remove('show-soldout-btn');
      soldOutButtonContainer.style.display = 'none';
    } else {
      // 再入荷ボタンなし：完売ボタンのコンテナを表示
      document.body.classList.add('show-soldout-btn');
      soldOutButtonContainer.style.display = '';
    }
  }
  
  checkAndToggle();
  setTimeout(checkAndToggle, 10);
  setTimeout(checkAndToggle, 50);
  setTimeout(checkAndToggle, 100);
  setTimeout(checkAndToggle, 200);
  setTimeout(checkAndToggle, 500);
  setTimeout(checkAndToggle, 1000);
  setTimeout(checkAndToggle, 2000);
  setTimeout(checkAndToggle, 3000);
})();